<template>
  <VMenu
    :distance="12"
    :instantMove="true"
    :themes="{ menu: { delay: { hide: 0 } } }"
    style="display: inline-block"
    @show="$emit('show')"
  >
    <template>
      <slot name="toggler"></slot>
    </template>
    <template #popper>
      <slot name="content"></slot>
    </template>
  </VMenu>
</template>

<script>
import 'floating-vue/dist/style.css'
import { Menu as VMenu } from 'floating-vue'

export default {
  name: 'Tooltip',
  components: {
    VMenu
  },
}
</script>
